import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { setRequerimiento } from '../../store/sagas/catalogoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

function Step1({ dadComponent }) {
  let { email } = dadComponent.state;

  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <p className="paragraph-2 light">Para completar tu requerimiento, ingresar el Email que usas para ingresar al app de Crosland.</p>
        <FormGroup className="mt-5 mx-auto" style={{maxWidth:280}}>
          <Input className="azul" type='text' value={email} disabled={true} />
        </FormGroup>
        <div className="text-center mt-5 mobile">
          <button type="button" className='btn-block red' onClick={() => { dadComponent.nextStep() }}>siguiente</button>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button type="button" className='btn-block red' onClick={() => { dadComponent.nextStep() }}>siguiente</button>
      </div>
    </div>
  )
}

function Step2({ dadComponent }) {
  let { text, errorValidacopn } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <p className="paragraph-2 light">Por favor ingrese el requerimiento.</p>
        <FormGroup className="mt-5 mx-auto w-100" style={{maxWidth:440}}>
          <Input type='textarea' placeholder="Requerimiento" rows='5' value={text} onChange={(e) => { let text = e.currentTarget.value; dadComponent.setText(text); }} />
        </FormGroup>
        <div className="text-center mt-5 mobile">
          <button type="button" disabled={text == '' || text == null} className='btn-block' style={{ backgroundColor: c.verdeClaro }} onClick={() => dadComponent.RegistrarRequerimiento()}>ENVIAR</button>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
              <button type="button" disabled={text == '' || text == null} className='btn-block' style={{ backgroundColor: c.verdeClaro }} onClick={() => dadComponent.RegistrarRequerimiento()}>ENVIAR</button>
      </div>
    </div>
  )
}

function Step3({ dadComponent, auth }) {
  const { } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <div className="empty" style={{maxWidth:560}}>
          <SvgAssets icon="icon-like" fill={c.celeste} />
          <h6 className="paragraph-1 mb-2" style={{ color: c.azulClaro }}>MUCHAS GRACIAS</h6>
          <p className="paragraph-2 text-center">Hola {auth.userRazonSocial}, muchas gracias por registrar tu requerimiento, en un máximo de 72 horas nos comunicaremos contigo.</p>
          <div className="text-center mt-5 mobile">
            <Link to="/dashboard">
              <button className='btn-block' style={{ backgroundColor: c.azulClaro }}>ENTENDIDO</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="text-center mt-5 desktop" style={{ justifyContent: 'center' }}>
        <Link to="/dashboard">
          <button className='btn-block' style={{ backgroundColor: c.azulClaro }}>ENTENDIDO</button>
        </Link>
      </div>
    </div>
  )
}

export class Requerimientos extends Component {
  static displayName = Requerimientos.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      loading: true,
      text: "", errorValidacopn: null, email: ""
    };
    this.backStep = this.backStep.bind(this);
  }
  setText = (value) => {
    this.setState({ text: value, errorValidacopn: "" })
  }
  RegistrarRequerimiento = () => {
    if (this.state.text == null || this.state.text == "")
      this.setState({ errorValidacopn: "Debe ingresar el requerimiento" })
    else {
      this.setState({ errorValidacopn: "" })
      let storageGeneral = localStorageCustom.prototype.getUsuario();
      this.postRequerimiento(storageGeneral.dealer.codcliente, storageGeneral.dealer.correoElectronico,
        this.state.text)
    }

  }
  componentDidMount() {
    window.scrollTo(0, 0)
    let result = localStorageCustom.prototype.getUsuario()
    this.setState({ email: result.dealer.correoElectronico, loading: false });
    // this.getIncidentes(data.Incidentes);
  }

  nextStep() {
    this.setState({ step: this.state.step + 1 })
  }

  backStep() {
    this.setState({ step: this.state.step - 1 })
  }

  renderStep() {
    const auth = this.context;
    switch (this.state.step) {
      case 0:
        return <Step1 dadComponent={this} />
      case 1:
        return <Step2 dadComponent={this} />
      case 2:
        return <Step3 dadComponent={this} auth={auth} />
      default:
        return <Step1 dadComponent={this} />
    }
  }

  render() {
    const { loading, step } = this.state;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Requerimiento</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Ayuda</li>
              <li>Requerimiento</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white">
            {step != 2?
              <a onClick={this.backStep} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a> : null
            }
            REQUERIMIENTO</h6>
            {this.renderStep()}
        </Container>
      </div>
    );
  }

  postRequerimiento = (CodigoDealer, CorreoElectronico, Requerimiento) => {
    this.setState({
      loading: true,
      data: { text: null, errorValidacopn: null }
    })
    setRequerimiento(CodigoDealer, CorreoElectronico, Requerimiento)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            text: null, errorValidacopn: null
          })

          this.nextStep();
          // this.props.navigation.navigate('AyudaGracias');
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Incidentes", error.message ?? null);
        });
      });

  }
}
